import { useMemo } from 'react';

import usePreferredRetailer from '@/hooks/use-preferred-retailer/use-preferred-retailer.ts';
import { NavigationItem } from '@/typings/generic.ts';

const useFilteredRightXfPaths = (rightXfPaths?: NavigationItem[]) => {
	const { hasPreferredRetailer } = usePreferredRetailer();

	const filteredRightXfPaths = useMemo(
		() =>
			rightXfPaths?.filter((path) => {
				if (
					path.id?.toLowerCase() === 'retailer' &&
					hasPreferredRetailer
				) {
					// exclude retailer when preferredRetailer is set
					return false;
				}
				if (
					path.id?.toLowerCase() === 'preferred-retailer' &&
					!hasPreferredRetailer
				) {
					// exclude preferred-retailer when preferredRetailer not set
					return false;
				}
				return true;
			}),
		[rightXfPaths, hasPreferredRetailer],
	);

	return filteredRightXfPaths;
};

export default useFilteredRightXfPaths;
